<template>
    <div>
        <header-nav :cur="1" />
        <div class="nav">
            <div class="navtab">
                <span class="top">
                    <span @click="toIndex()" style="cursor:pointer"  >首页</span>&nbsp;>
                    <span class="infor">资讯</span>
                </span>
                <div class="newbox">
                    <div>
                        <div class="newtop">最新课程资讯</div>
                        <div class="newbot">掌握行业动态，帮助快速学习</div>
                    </div>
                    <div class="input">
                        <input placeholder="请输入搜索关键字" type="text"  v-model="queryParams.articleTitle"/>
                        <div class="select" @click="getList()">搜索</div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 行业资讯 -->
        <div class="navtab">
            <div class="navlist">
                <div class="navname" v-for="(item, index) in list" :key="index" :class="{ active: index === int }" @click="actnav(index,item.id)">
                    {{ item.name }}
                </div>
            </div>
			<div v-for="(item, index) in dataList" :key="index"    @click="todetail(item.wid)" style="cursor:pointer" >
			    <div class="title">{{item.articleTitle}}</div>
			    <div class="content">
			        <!-- <img :src="$api.url+item.articleImage" :alt="item.articleTitle" v-if="item.articleImage != null"/> -->
			        <div class="imgright">
			            <div class="ignore article" v-html="item.content">
			               <!-- {{}} -->
			            </div>
			            <div class="time">
			                <span>发布时间：{{item.createTime}}</span>
			                <span>阅读量：{{item.number_hit}}</span>
			                <span>作者：{{item.authorName}}</span>
			            </div>
			        </div>
			    </div>
			</div>

        </div>
		<v-pagination :total="total" :display='queryParams.pageSize' :current-page='queryParams.pageNum' @pagechange="pagechange"></v-pagination>
        <footer-nav />
    </div>
</template>
<script>
import {queryArticleList,queryArticleById,latestArticleList} from '@/api/article.js'
import headerNav from '../../components/HeaderNav.vue';
import footerNav from '../../components/FooterBar';
import pagination from '@/components/common/pagination'
export default {
    components: {
		'v-pagination': pagination,
        'header-nav':headerNav,
        'footer-nav':footerNav,
    },
    data() {
        return {
			queryParams: {
			  pageNum: 1,
			  pageSize: 10,
			  articleTypeId:1,
			  articleTitle:null
			},
            int: 0,
			list: [
			   {
				  'id':1,
				  'name':'行业资讯'
			   },
			   {
				  'id':2,
				  'name':'培训动态'
			   },
			   {
				  'id':3,
				  'name':'通知公告'
			   }
			],
			dataList:[],
			total:0,
			typeId:1,
        };
    },
	created() {
		this.getList();
	},
    methods: {
		toIndex(){
			this.$router.push('/');
		},
		getList(){
			queryArticleList(this.queryParams).then(res => {
				var list = res.rows;
				this.dataList = [];
				this.dataList = res.rows;
				this.total = res.total;
			})
		},
		pagechange(currentPage){
			console.log(currentPage);
		    this.queryParams.pageNum=currentPage;
		    // ajax请求, 向后台发送 currentPage, 来获取对应的数据
		    this.getList();
	    },
        actnav(int,typeId) {
            this.int = int;
			this.queryParams.pageNum = 1;
			this.queryParams.articleTypeId = typeId;
			this.getList();
        },
        todetail(id) {
			this.$router.push({path:'information/detail',query:{id:id}});
        },
    },
};
</script>
<style lang="less" scoped>
     // 公共
     .navtab {
         width: 1280px;
         margin: 0 auto;
     }
     .color {
         color: #2961EF !important;
     }
     .ignore {
         overflow: hidden;
         text-overflow: ellipsis;
         display: -webkit-box;
         -webkit-box-orient: vertical;
         -webkit-line-clamp: 3;
     }
     .nav {
         background: #f7f8fa;
         width: 100%;
         height: 177px;
         .top {
             display: block;
             font-size: 16px;

             font-weight: 300;
             color: #777777;
             padding: 19px 0 24px;
             .infor {
                 color: #2961EF;
             }
         }
         .newbox {
             display: flex;
             justify-content: space-between;
             align-items: center;
             .newtop {
                 font-size: 26px;
                 color: #000000;
                 margin-bottom: 5px;
             }
             .newbot {
                 font-size: 16px;
                 color: #888888;
             }
             .input {
                 width: 497px;
                 height: 59px;
                 background: #ffffff;
                 box-shadow: 3px 3px 10px 1px rgba(11, 19, 72, 0.050980392156862744);
                 border-radius: 30px;
                 position: relative;
                 input {
                     border: none;
                     position: absolute;
                     left: 30px;
                     top: 0;
                     height: 59px;
                     line-height: 59px;
                     width: 365px;
                     font-size: 16px;

                     font-weight: 300;
                     color: #777777;
                 }
                 .select {
                     position: absolute;
                     right: 12px;
                     top: 8px;
                     width: 74px;
                     height: 43px;
                     line-height: 43px;
                     background: #2961EF;
                     border-radius: 30px;
                     font-size: 16px;

                     font-weight: 300;
                     color: #ffffff;
                     text-align: center;
                 }
             }
         }
     }
     // 列表
     .navlist {
         display: flex;
         justify-content: center;
         .navname {
             cursor: pointer;
             width: 130px;
             height: 45px;
             line-height: 45px;
             text-align: center;
             border-radius: 5px 5px 0px 0px;
             margin: 30px 0 39px;
             font-size: 20px;
         }
         .active {
             border-bottom: 5px solid #2961EF;
             color: #2961EF;
         }
     }
     .title {
         font-size: 20px;
         color: #000000;
         margin-bottom: 16px;
     }
     .content {
         border-bottom: 5px solid #f7f8fa;
         padding-bottom: 20px;
         margin-bottom: 20px;
         img {
             width: 230px;
             height: 141px;
             display: inline-block;
             vertical-align: middle;
             margin-right: 20px;
         }
         .imgright {
             display: inline-block;
             vertical-align: middle;
             .article {
                 width: 100%;
                 height: 75px;
                 line-height: 25px;
                 font-size: 16px;
                 font-weight: 400;
                 color: #888;
                 overflow: hidden;
                 text-indent: 2em;
                 margin-bottom: 10px;
             }
             .time {
                 font-size: 16px;
                 font-weight: 400;
                 color: #5883f0;
                 position: relative;
                 span {
                     vertical-align: middle;
                     padding: 0 30px;
                     font-size: 14px;
                     height: 15px;
                     line-height: 15px;
                     display: inline-block;
                     border-right: 1px solid #93AFF6;
                     // &::after {
                     //     content: '';
                     //     height: 18px;
                     //     width: 1px;
                     //     position: absolute;
                     //     right: 10px;
                     //     top: 0;
                     // }
                     &:nth-child(1) {
                         padding: 0 30px 0 0;
                     }
                     &:nth-child(3) {
                         border-right: none;
                     }
                 }
             }
         }
     }
     // 分页
     .paging {
         width: 534px;
         height: 50px;
         background: rgba(112, 112, 112, 0.18);
         border-radius: 37px 37px 37px 37px;
         margin: 35px auto;
         display: flex;
         align-items: center;
         font-size: 16px;

         font-weight: 300;
         color: #888888;
         justify-content: space-around;
         text-align: center;
         div {
             height: 50px;
             line-height: 50px;
             border-right: 1px solid rgba(112, 112, 112, 0.2);
             width: 20%;
             &:nth-child(5) {
                 border: none;
             }
         }
     }

</style>
